export const CUSTOMERS_GRID_CHANGE_COLUMNS = 'CUSTOMERS_GRID_CHANGE_COLUMNS';
export const CUSTOMERS_GRID_CHANGE_PAGE = 'CUSTOMERS_GRID_CHANGE_PAGE';
export const CUSTOMERS_GRID_MANAGE_COLUMNS = 'CUSTOMERS_GRID_MANAGE_COLUMNS';
export const CUSTOMERS_GRID_CHANGE_ORDERBY = 'CUSTOMERS_GRID_CHANGE_ORDERBY';
export const CUSTOMERS_GRID_UPDATE_CUSTOM_CONFIGURATION = 'CUSTOMERS_GRID_UPDATE_CUSTOM_CONFIGURATION';
export const LAUNCH_CUSTOMER_DETAIL_MODAL = 'LAUNCH_CUSTOMER_DETAIL_MODAL';

export const customerGridChangeColumns = (statusViewId, filterViewId, columns) => {
  return {
    type: CUSTOMERS_GRID_CHANGE_COLUMNS,
    statusViewId,
    filterViewId,
    columns,
  };
};

export const customerGridChangeOrderBy = (statusViewId, filterViewId, columns) => ({
  type: CUSTOMERS_GRID_CHANGE_ORDERBY,
  statusViewId,
  filterViewId,
  columns,
});

export const customerGridChangePage = (newPage, pageSize) => {
  return {
    type: CUSTOMERS_GRID_CHANGE_PAGE,
    newPage,
    pageSize,
  };
};

export const updateCustomViewGridConfiguration = (customViewColumnConfiguration) => ({
  type: CUSTOMERS_GRID_UPDATE_CUSTOM_CONFIGURATION,
  customViewColumnConfiguration,
});

export const launchCustomerDetailModal = (customerId) => ({
  type: LAUNCH_CUSTOMER_DETAIL_MODAL,
  customerId,
});
